import ReactQuill from 'react-quill';
// Inline loader syntax: https://webpack.js.org/concepts/loaders/#inline
import '!!style-loader!css-loader!react-quill/dist/quill.snow.css';

import React from 'react';
// Must be after the quill styles
import styles from './styles.scss';

type HtmlString = string;

type RichTextInputProps = {
  value: HtmlString;
  onChange: (html: HtmlString) => void;
  width?: number | string;
  placeholder?: string,
};

const RichTextInput = React.forwardRef(({placeholder, width, value, onChange }: RichTextInputProps, ref) => (
  <div className={styles.wrapper} style={{width}} data-test-id="rich-text-input">
    <ReactQuill
      ref={ref as React.LegacyRef<ReactQuill>}
      theme="snow"
      value={value}
      onChange={v => onChange(v)}
      placeholder={placeholder}
      modules={{
        toolbar: [
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          ['link'],
          ['clean']
        ]
      }}
    />
  </div>
));

export default RichTextInput;
